import Vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import { messagesEN } from '../locales/messages_EN';
import { messagesIrl } from '../locales/messages_IRL';

export let i18nInstance = null;

const I18N_OPTIONS_KEY = 'i18n-options';
const JA_LOCALIZATION_DISABLED = JSON.parse(
	process.env.VUE_APP_JA_IS_LOCALIZATION_LOCALE
);
const JA_LOCALIZATION_IRL = JSON.parse(process.env.VUE_APP_JA_LOCALIZATION_IRL);

function getI18nOptions() {
	return JSON.parse(localStorage.getItem(I18N_OPTIONS_KEY));
}

function setI18nOptions(i18nOptions) {
	localStorage.setItem(I18N_OPTIONS_KEY, JSON.stringify(i18nOptions));
}

let i18nOptions = getI18nOptions();

export async function getLocalizationMessages(facilityId = 0) {
	let messages = {};
	const navigatorLanguage = navigator.language;
	try {
		const axiosData = {
			url: '/api/Data/Localize',
			method: 'GET',
			params: {
				facilityId: facilityId
			},
			withCredentials: true
		};

		const resp = await axios(axiosData);

		if (resp.data) {
			sessionStorage.setItem('currentLanguage', navigatorLanguage);
			return resp.data;
		} else {
			throw 'Localization: Unable to connect with the service. The default language is in use instead.';
		}
	} catch (e) {
		console.warn(e);
		if (!i18nOptions) {
			if (!messages.hasOwnProperty('en')) {
				messages['en'] = messagesEN;
			}
		} else {
			if (i18nOptions.messages.currency == 'USD') {
				messages = i18nOptions.messages;
			} else {
				messages['en'] = messagesEN;
			}
		}
		return messages;
	}
}

export async function initI18n() {
	Vue.use(VueI18n);
	const navigatorLanguage = navigator.language;
	let locale = navigatorLanguage;
	if (navigator.onLine) {
		let messages = {};
		if (JA_LOCALIZATION_IRL == true) {
			messages['en'] = messagesIrl;
		} else if (JA_LOCALIZATION_DISABLED == true) {
			messages['en'] = messagesEN;
		} else {
			messages = await getLocalizationMessages(0);
		}

		i18nOptions = {};
		i18nOptions.locale = locale;
		i18nOptions.messages = messages;
		i18nOptions.silentFallbackWarn = true;

		setI18nOptions(i18nOptions);
	}
	i18nInstance = new VueI18n(i18nOptions);
	return i18nInstance;
}

export default {
	initI18n,
	getI18nOptions
};
